import { LayoutCheckoutTable } from "@/Layout/DefaultCheckout/LayoutCheckoutTable";
import Skeleton from "react-loading-skeleton";

export const DefaultSummary = () => {
  return (
    <LayoutCheckoutTable>
      <thead>
        <tr>
          <th scope="col">
            <Skeleton />
          </th>
          <th scope="col">
            <Skeleton />
          </th>
          <th scope="col">
            <Skeleton />
          </th>
          <th scope="col">
            <Skeleton />
          </th>
        </tr>
      </thead>
      <tbody className="text-center">
        <tr>
          <td>
            <Skeleton />
          </td>
          <td className="develop___text__summary">
            <Skeleton />
          </td>
          <td className="develop___text__summary">
            <Skeleton />
          </td>
          <td className="develop___text__summary">
            <Skeleton />
          </td>
        </tr>
      </tbody>
    </LayoutCheckoutTable>
  );
};
